import { BadgeOption } from 'src/types';
import { PAYMENT_STATUS, PAYMENT_TYPE, PAYMENT_TYPE_FOR_TABLE_BADGE } from 'src/features/payments/utils/types';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { paymentsMessages } from 'src/features/payments/utils/messages';

export const PAYMENT_TYPE_BADGE_OPTIONS: Record<PAYMENT_TYPE_FOR_TABLE_BADGE, BadgeOption> = {
    [PAYMENT_TYPE_FOR_TABLE_BADGE.CASH]: {
        label: moneyAccountsMessages.cash,
        icon: ICON_MAP.CASH,
        theme: 'green',
    },
    [PAYMENT_TYPE_FOR_TABLE_BADGE.CARD]: {
        label: moneyAccountsMessages.card,
        icon: ICON_MAP.CARD,
        theme: 'yellow',
    },
    [PAYMENT_TYPE_FOR_TABLE_BADGE.BANK]: {
        label: moneyAccountsMessages.bank,
        icon: ICON_MAP.BANK,
        theme: 'blue',
    },
    // [PAYMENT_TYPE.ONLINE]: {
    //     label: moneyAccountsMessages.online,
    //     icon: ICON_MAP.ONLINE,
    //     theme: 'orange',
    // },
};

export const PAYMENT_TYPE_TRANSLATION_MAP: Record<PAYMENT_TYPE, { id: string; defaultMessage: string }> = {
    [PAYMENT_TYPE.BANK]: moneyAccountsMessages.bank,
    [PAYMENT_TYPE.CASH]: moneyAccountsMessages.cash,
};

export const PAYMENT_STATUS_BADGE_OPTIONS: Record<PAYMENT_STATUS, BadgeOption> = {
    [PAYMENT_STATUS.PAID]: {
        label: paymentsMessages.paid,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [PAYMENT_STATUS.CANCELLED]: {
        label: paymentsMessages.cancelled,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
    [PAYMENT_STATUS.FAILED]: {
        label: paymentsMessages.failed,
        icon: ICON_MAP.X_MARK,
        theme: 'orange',
    },
    [PAYMENT_STATUS.REFUNDED]: {
        label: paymentsMessages.refunded,
        icon: ICON_MAP.REFUND,
        theme: 'gray',
    },
    [PAYMENT_STATUS.ROLLBACK]: {
        label: paymentsMessages.rollback,
        icon: ICON_MAP.FROZEN,
        theme: 'blue',
    },
};
